// safetyFormLists/nearMissLists/state.js

import { filtersInitialState } from "../../shared/filters/filtersState";

export const nearMissListInitialState = {
  items: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedNearMiss: null,
  filters: filtersInitialState({ status: "Draft" }),
};
